import * as types from '../constants/ActionTypes';

const initialState = {
  display: false,
  isLoadingArticle: false,
  errorArticle: false,
  article: undefined,
  relatedArticles: [],
};

let contactOptionSelected = false;

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_ARTICLE:
      contactOptionSelected = false;
      return Object.assign({}, state, {
        isLoadingArticle: true,
        errorArticle: false,
        article: undefined,
        display: true,
      });

    case types.RECEIVE_ARTICLE_RESPONSE:
      return Object.assign({}, state, {
        isLoadingArticle: false,
        errorArticle: false,
        article: action.payload,
        display: !contactOptionSelected,
      });

    case types.RECEIVE_ARTICLE_ERROR:
      return Object.assign({}, state, {
        isLoadingArticle: false,
        errorArticle: true,
        article: undefined,
        display: !contactOptionSelected,
      });
    case types.REQUEST_RELATED_ARTICLE:
      return Object.assign({}, state, {
        relatedArticles: [],
      });
    case types.RECEIVE_RELATED_ARTICLE_RESPONSE:
      return Object.assign({}, state, {
        relatedArticles: action.payload,
      });
    case types.RECEIVE_RELATED_ARTICLE_ERROR:
      return Object.assign({}, state, {
        relatedArticles: [],
      });
    case types.RESET_RELATED_ARTICLE:
      return Object.assign({}, state, { relatedArticles: [] });
    case types.REQUEST_BY_EMAIL:
      contactOptionSelected = true;
      return Object.assign({}, state, {
        display: false,
      });

    case types.SELECT_TOPIC_L1:
    case types.SELECT_TOPIC_L2:
    case types.SELECT_TOPIC_L3:
    case types.SELECT_TOPIC_RESET:
    case types.REQUEST_CALLUS :
    case types.RECEIVE_CALLUS_RESPONSE :
    case types.RECEIVE_EMPTY_FIELDS:
      return Object.assign({}, state, { display: false });
    case types.CHANGE_TOPIC:
    case types.CANCEL_EMAIL_FORM:
      contactOptionSelected = false;
      return Object.assign({}, state, { display: true });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./contactUs/reducers/reducer-active-article.js